import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthContext } from '../../contexts/AuthContext';

type RoleCheckerProps = {
 resource: string;
 action: string;
 children: ReactNode;
};

const RoleChecker = ({ resource, action, children }: RoleCheckerProps) => {
 const { t } = useTranslation();
 const { hasRole } = useAuthContext();

 const hasRequiredRole = hasRole(resource, action);
 const roleName = `${resource}.${action}`;

 if (hasRequiredRole) {
  return <>{children}</>;
 }

 return (
  <Box sx={{ px: 3, pb: 3 }}>
   <Typography
    sx={{
     fontSize: 14,
     fontWeight: 400,
     color: (theme) => theme.palette.kemek.darkGray,
    }}
   >
    {t('global.missingRoleMessage', {
     defaultValue: 'Your user does not have a role: {{roleName}}',
     roleName,
    })}
   </Typography>
  </Box>
 );
};

export default RoleChecker;

